import { CopyToClipboard as CopyToClipboard$1, ANIMATION_DURATION_IN_MILLISECONDS } from './CopyToClipboard.js';

const CopyToClipboard = Object.assign(CopyToClipboard$1, {
    animationDuration: ANIMATION_DURATION_IN_MILLISECONDS,
});

export { CopyToClipboard };
